<template>
    <div>
        <Loader v-if="loading" text="Loading your surveys" />
        <template v-else>
        <p v-if="!answers.length && !user360Surveys.length">
            <slot name="empty" />
        </p>

        <table class="mb-20 shadow-lg bg-white table-auto w-full"
            v-if="answers.length || user360Surveys.length">
            <thead>
                <tr class="font-bold text-lg">
                    <th class="bg-gray-100 w-8"></th>
                    <th class="bg-gray-100 text-left px-8 py-4">{{
                        $t('default.dashboard.survey_table_name') }}
                    </th>
                    <th class="text-center bg-gray-100">{{ $t('default.dashboard.survey_table_date') }}</th>
                    <th class="bg-gray-100"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(ans, i) in answers" :key="'ans-' + i" :class="i % 2 ? 'bg-gray-100' : ''">
                    <td class="px-3 py-4 survey-icon">
                        <FontAwesomeIcon title="Survey" icon="fa-solid fa-file-text" />
                    </td>
                    <td class="px-8 py-4">{{ ans.survey_name }}</td>
                    <td class="text-center px-8 py-4">{{ formatedDatetime(ans.created_formatted) }}</td>
                    <td class="px-2 py-2 md:px-8 md:py-4 text-center w-1/5">
                        <router-link :to="{ name: 'userSurveyAnswers', params: { id: ans.id, survey: ans.survey } }"
                            class="font-bold text-green hover:text-green-dark cursor-pointer">
                            {{ $t('default.dashboard.view') }}
                        </router-link>
                    </td>
                </tr>
                <tr v-for="(survey, i) in user360Surveys" :key="'360-' + i"
                    :class="(answers.length + i) % 2 ? 'bg-gray-100' : ''">
                    <td class="px-3 py-4 survey-icon">
                        <FontAwesomeIcon title="360 Survey" icon="fa-solid fa-recycle" />
                    </td>
                    <td class="px-8 py-4">
                        {{ translate(survey) }}
                    </td>
                    <td class="text-center px-8 py-4">{{ formatedDatetime(survey.created) }}</td>
                    <td class="px-2 py-2 md:px-8 md:py-4 text-center w-1/5">
                        <router-link :to="`/user/${stateUserId}/survey360/${survey.id}`"
                            class="font-bold text-green hover:text-green-dark cursor-pointer">
                            {{ $t('default.navigation.surveyResults') }}
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
        </template>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Loader from '@/components/Loader.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { stringToDatetime } from '@/datetimeUtils'

const props = defineProps({
    userId: { type: [String, Number], required: true },
})

const store = useStore()
const { locale } = useI18n()
const loading = ref(true)

const isAdminUser = computed(() => store.getters['user/isAdminUser'])
const stateUserId = computed(() => store.state.user.user?.id)

const answers = computed(() => store.state.user.userAnswers || [])
const user360Surveys = computed(() => {
    if (isAdminUser.value) return store.getters['survey360/getSurveys'] || []
    return store.state.user.user360Surveys || []
})

const formatedDatetime = (str) => stringToDatetime(str)

const translate = (survey) => {
    const translations = {}
    survey.translations.forEach((t) => { translations[t.locale] = t.name })
    return translations[locale.value]
        ?? translations['fi']
        ?? translations['en']
        ?? translations['sv']
        ?? survey.name
}

onMounted(() => {
    store.dispatch('user/fetchUserAnswers', { usr: props.userId, redirectOn403: true }).then(() => {
        if (isAdminUser.value) {
            return store.dispatch('survey360/fetchForTargetUser', props.userId)
        } else {
            return store.dispatch('user/fetchUserAccepted360Surveys')
        }
    }).finally(() => {
        loading.value = false
    })
})
</script>

<style scoped>
.survey-icon {
    color: var(--text-grey);
}
</style>
